import React from "react";
import { X } from "lucide-react";

const AttachmentPreviewModal = ({ show, url, onClose }) => {
  if (!show || !url) return null;

  const isImage = url.match(/\.(jpeg|jpg|png|gif|webp)$/i);
  const isPDF = url.match(/\.pdf$/i);
  const isExcel = url.match(/\.(xlsx|xls|csv)$/i);

  const modalWidth = isExcel ? "max-w-3xl" : "max-w-5xl";

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-xl p-4 w-full shadow-xl relative ${modalWidth}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-black"
        >
          <X size={22} />
        </button>

        <h2 className="text-lg font-semibold mb-4">Attachment Preview</h2>

        {isImage && (
          <img
            src={url}
            alt="Attachment"
            className="max-h-[70vh] w-auto mx-auto rounded-lg shadow"
          />
        )}

        {isPDF && (
          <iframe
            src={url}
            className="w-full h-[70vh] rounded-lg shadow"
            title="PDF Preview"
          ></iframe>
        )}

        {isExcel && (
          <div className="text-center py-10">
            <p className="text-gray-700 mb-4">
              Excel files cannot be previewed.
            </p>

            <a
              href={url}
              download
              className="px-4 py-2 bg-gradient-to-r from-[#0061A4] to-[#00ACED] text-white rounded-lg shadow"
            >
              Download Excel File
            </a>
          </div>
        )}

        {!isImage && !isPDF && !isExcel && (
          <div className="text-center text-gray-500">
            Unable to preview this file type.
          </div>
        )}
      </div>
    </div>
  );
};

export default AttachmentPreviewModal;
